import Chart from "react-apexcharts";
import classes from './Box.module.css'
import ReactApexChart from "react-apexcharts";

export default function TasksGraphBox({values, labels, title}) {


    // Given an object, reduce it to a sum of its numeric values
    function sumObjectValues(obj) {
        return Object.values(obj).reduce((acc, val) => acc + (typeof val === 'number' ? val : 0), 0);
    }

    const customData = {
          
        series: values,
        options: {
          chart: {
            width: 200,
            type: 'pie',
          },
          legend: {
                show: true,
                position: 'bottom'
              },
          labels: labels,
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              
            }
          }],
          title: {
              text: title,
              align: 'center'
            },
            dataLabels: {
                // ...mockChartData.options.dataLabels,
                enabled: true,
   
                // formatter: function (val) { return val },
                formatter: (val, { seriesIndex, w }) => w.config.series[seriesIndex],
                style: {
                    fontSize: '15px'
                }
            },
        },
        
      
    }

    return <div className={classes.item}>
        <div id="chart">
            <ReactApexChart options={customData.options} series={customData.series} type="pie" width={220} />
            </div>
        <div id="html-dist"></div>
    </div>
}